












import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const store = sl.get('store');
    const hasCommentPermission = store.hasPermission('ADD_COMMENTS');

    let state;

    if (hasCommentPermission) {
      state = reactive({
        routes: [
          {
            label: 'Profile',
            path: 'profile',
          },
          {
            label: 'Drafts',
            path: 'drafts',
          },
          {
            label: 'Comments',
            path: 'comments',
          },
        ],
      });
    } else {
      state = reactive({
        routes: [
          {
            label: 'Profile',
            path: 'profile',
          },
          {
            label: 'Drafts',
            path: 'drafts',
          },
          {
            label: 'Preferences',
            path: 'preferences',
          },
        ],
      });
    }

    return {
      ...toRefs(state),
      hasCommentPermission,
    };
  },
});
